
import { Fragment, useEffect, useState, useRef } from "react";
import basvuruDetailLists from "../../services/basvuruDetailLists";
import basvuruAnaDurumList from "../../services/basvuruAnaDurumList"
import { Divider, message, Table, Card, Form, Label, Row, Select, Col, Drawer, Modal, Spin, Input, Space, Button, Typography, InputNumber, Popconfirm } from 'antd';
import { UnorderedListOutlined } from '@ant-design/icons'
import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from "recharts";
import history from "../../history";
import queryString from 'query-string';
import { DATE_FORMAT } from "../../constants";
import moment from "moment";
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import ReactExport from "react-export-excel";
import ExcelExport from '../ExcelExport';
import { FileExcelOutlined, DownloadOutlined } from "@ant-design/icons";
import HarcEkleSecimForm from "../HarcEkleSecimForm/HarcEkleSecimForm"
import HarcTurAktifTarifeGetir from "../../services/HarcTurAktifTarifeGetir"
import harcTurTanimList from "../../services/harcTurTanimLists";
import BasvuruTahakkukOlustur from "../../services/BasvuruTahakkukOlustur";
import basvuruHarcList from "../../services/basvuruHarcList";

const { Option } = Select;
const parsed = queryString.parse(history.location.search);

const HarcEkleForm = (props) => {

  const [dates, setDates] = useState([moment(), moment()]);
  const belgeGrubuId = parsed.belgeGrubuId;
  const [harcTurTanims, setHarcTurTanims] = useState([]);
  const [aktifTarifeLists, setAktifTarifeLists] = useState([]);
  const [aktifTarifeListsCount, setAktifTarifeListsCount] = useState(0);
  const [basvuruHarcLists, setBasvuruHarcLists] = useState([]);
  const [basvuruHarcListsCount, setBasvuruHarcListsCount] = useState(0);
  const [form] = Form.useForm();
  const basvuruId = parseInt(parsed.basvuruId);
  const [spining, setSpining] = useState(false);
  let [searchText, setSearchText] = useState("");
  let [searchInput, setsearchInput] = useState("");
  let [searchedColumn, setsearchedColumn] = useState("");
  const [queryDates, setQueryDates] = useState([undefined, undefined]);
  let [turTanimId, setTurTanimId] = useState(0);
  let [relatedAltSurecTipi, setRelatedAltSurecTipi] =useState(0);
  const [selectionType, setSelectionType] = useState('checkbox');
  let [selectedRowKeys, setSelectedRowKeys] = useState([]);

  

  useEffect(() => {
    if(parsed.relatedAltSurecTipi != null || parsed.relatedAltSurecTipi !== undefined)
    {
      setRelatedAltSurecTipi(parseInt(parsed.relatedAltSurecTipi));
    }

    harcTurTanimList().then(res => { setHarcTurTanims(res.data.result) });
    basvuruHarcList(basvuruId).then(res => {
      setBasvuruHarcLists(res.data.result);
      setBasvuruHarcListsCount(res.data.result.length);
    });

    setQueryDates(dates);
  }, []);

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            searchInput = node;
          }}
          placeholder={`Ara `}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            // icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Ara
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Sıfırla
          </Button>
        </Space>
      </div>
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        text
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    searchText = selectedKeys[0];
    searchedColumn = dataIndex;
  };

  const handleReset = clearFilters => {
    clearFilters();
    searchText = '';
  };

  const tahakkukOlustur = () => {
    setSpining(true);
    var selectedRows = aktifTarifeLists.filter(item => selectedRowKeys.includes(item.id));
    var requestModel = {};
    if (selectedRows.length > 0) {
      requestModel.basvuruId = basvuruId;
      requestModel.turTanimId = turTanimId;
      requestModel.relatedAltSurecTipi=relatedAltSurecTipi;
      requestModel.tarifeDetayList = [];
      for (var i = 0; i < selectedRows.length; i++) {
        if (selectedRows[i].deger != null && selectedRows[i].katSayi != null && selectedRows[i].kentselDonusum != null) {
          requestModel.tarifeDetayList.push({
            "bgsTarifeId": selectedRows[i].bgsTarifeId,
            "bgsTarifeAdi": selectedRows[i].tarifeAdi,
            "bgpServisId": selectedRows[i].bgpServisId,
            "bgpGelirkodId": selectedRows[i].bgpGelirkodId,
            "deger": selectedRows[i].deger,
            "kat": selectedRows[i].katSayi,
            "kentselDonusum": selectedRows[i].kentselDonusum
          });
        }
        else {
          message.warning("Zorunlu alanlar doldurulmalıdır. (Değer,Katsayı,Kentsel Dönüşüm)");
          setSpining(false);
          return;
        }
      }

      // TODO Metod çağrılacak

      BasvuruTahakkukOlustur(requestModel).then(res => { res.data.success ? success('Tahakkuk Oluşturulmuştur.') : error(res.data.message); setSpining(false); })
        .catch(ex => {
          setSpining(false);
        })
      basvuruHarcList(basvuruId).then(res => { setBasvuruHarcLists(res.data.result) });
    }
    setSpining(false);
  }
  const success = (text) => {
    message.success(text);
  };
  const error = (text) => {
    message.error(text);
  };

  const clearFormField = () => {
    setSelectedRowKeys([]);
    setAktifTarifeLists([]);
  }

  function onChange(value, key, record) {
    record[key] = value;
    console.log('changed', value);
  }

  let aktifTarifeColumns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.id - b.id,
      ...getColumnSearchProps('id'),
    },
    {
      title: 'Tarife Adi',
      dataIndex: 'tarifeAdi',
      key: 'tarifeAdi',
      width: 200,
      sorter: (a, b) => a.tarifeAdi - b.tarifeAdi,
      ...getColumnSearchProps('tarifeAdi'),
    },
    {
      title: 'Yıl',
      key: 'yil',
      dataIndex: 'yil',
      sorter: (a, b) => a.yil - b.yil,
      ...getColumnSearchProps('yil'),
    },
    {
      title: 'Bgp Gelir Kod',
      dataIndex: 'bgpGelirkodAdi',
      key: 'bgpGelirkodAdi',
      sorter: (a, b) => a.bgpGelirkodAdi - b.bgpGelirkodAdi,
      ...getColumnSearchProps('bgpGelirkodAdi'),
    },
    {
      title: 'Bgp Servis Adi',
      width: 200,
      dataIndex: 'bgpServisAdi',
      key: 'bgpServisAdi',
      sorter: (a, b) => a.bgpServisAdi - b.bgpServisAdi,
      ...getColumnSearchProps('bgpServisAdi'),
    },
    {
      title: 'İlk Değer',
      dataIndex: 'ilkDeger',
      key: 'ilkDeger',
      width: 120,
      sorter: (a, b) => a.ilkDeger - b.ilkDeger,
      ...getColumnSearchProps('ilkDeger'),
    },
    {
      title: 'Son Değer',
      dataIndex: 'sonDeger',
      key: 'sonDeger',
      sorter: (a, b) => a.sonDeger - b.sonDeger,
      ...getColumnSearchProps('sonDeger'),
    },
    {
      title: 'Değer *',
      dataIndex: 'deger',
      key: 'deger',
      render: (text, record, value) => (
        <div>
          <InputNumber
            min={record.ilkDeger}
            max={record.sonDeger}
            // formatter={value => `${value}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '1,')}
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
            onChange={value => onChange(value, 'deger', record)}
          />
          {' ' + record.birim}
        </div>
      )

    }, {
      title: 'Katsayı *',
      dataIndex: 'katSayi',
      key: 'katSayi',
      render: (text, record, value) => (
        <InputNumber
          required
          min={1}
          parser={value => value.replace(/\$\s?|(,*)/g, '')}
          onChange={value => onChange(value, 'katSayi', record)}
        />
      )

    },
    {
      title: 'Kentsel Dönüşüm *',
      dataIndex: 'kentselDonusum',
      key: 'kentselDonusum',
      render: (text, record, value) => (
        <InputNumber
          required
          min={0.01}
          max={1}
          parser={value => value.replace(/\$\s?|(,*)/g, '')}
          onChange={value => onChange(value, 'kentselDonusum', record)}
        />
      )

    },
  ]

  let kodHarcList = [
    {
      title: 'Başvuru No',
      dataIndex: 'basvuruNo',
      key: 'basvuruNo',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.basvuruNo - b.basvuruNo,
      ...getColumnSearchProps('basvuruNo'),
    },
    {
      title: 'Harç Türü',
      dataIndex: 'harcTuru',
      key: 'harcTuru',
      sorter: (a, b) => a.harcTuru - b.harcTuru,
      ...getColumnSearchProps('harcTuru'),
    },
    {
      title: 'Durum',
      dataIndex: 'stateDescription',
      key: 'stateDescription',
      sorter: (a, b) => a.stateDescription - b.stateDescription,
      ...getColumnSearchProps('stateDescription'),
    },
    {
      title: 'Gönderim Durumu',
      dataIndex: 'gonderimDurumu',
      key: 'gonderimDurumu',
      sorter: (a, b) => a.gonderimDurumu - b.gonderimDurumu,
      ...getColumnSearchProps('gonderimDurumu'),
    },
    {
      title: 'Ödeme Durumu',
      dataIndex: 'odemeDurumu',
      key: 'odemeDurumu',
      sorter: (a, b) => a.odemeDurumu - b.odemeDurumu,
      ...getColumnSearchProps('odemeDurumu'),
    },
    {
      title: 'Bgs Tahakkuk Id',
      dataIndex: 'bgsTahakId',
      key: 'bgsTahakId',
      sorter: (a, b) => a.bgsTahakId - b.bgsTahakId,
      ...getColumnSearchProps('bgsTahakId'),
    },
    {
      title: 'Muhatap Id',
      dataIndex: 'muhatapId',
      key: 'muhatapId',
      sorter: (a, b) => a.muhatapId - b.muhatapId,
      ...getColumnSearchProps('muhatapId'),
    },
    {
      title: 'Değer',
      dataIndex: 'deger',
      key: 'deger',
      sorter: (a, b) => a.deger - b.deger,
      ...getColumnSearchProps('deger'),
    },
    {
      title: 'Katsayı',
      dataIndex: 'kat',
      key: 'kat',
      sorter: (a, b) => a.kat - b.kat,
      ...getColumnSearchProps('kat'),
    },
    {
      title: 'Kentsel Dönüşüm',
      dataIndex: 'kentselDonusum',
      key: 'kentselDonusum',
      sorter: (a, b) => a.kentselDonusum - b.kentselDonusum,
      ...getColumnSearchProps('kentselDonusum'),
    },
    {
      title: 'Durum Adı',
      dataIndex: 'stateDescription',
      key: 'stateDescription',
      sorter: (a, b) => a.stateDescription - b.stateDescription,
      ...getColumnSearchProps('stateDescription'),
    },
    {
      title: 'Dosya Id',
      dataIndex: 'yrsDosyaId',
      key: 'yrsDosyaId',
      sorter: (a, b) => a.yrsDosyaId - b.yrsDosyaId,
      ...getColumnSearchProps('yrsDosyaId'),
    },
    {
      title: 'Harç Tutarı(TL)',
      dataIndex: 'harcTutari',
      key: 'harcTutari',
      sorter: (a, b) => a.harcTutari - b.harcTutari,
      ...getColumnSearchProps('harcTutari'),
    },

  ]
  const onFinish = (values) => {
    getReportByFilter(values.harcTurTanimObjectIdRef, basvuruId);

  }
  const getReportByFilter = (yrsTurId, basvuruId) => {
    setSpining(true);
    let filterModel = {};

    if (yrsTurId !== undefined && yrsTurId != null) {
      filterModel.yrsTurId = yrsTurId;
      setTurTanimId(yrsTurId);
    }
    if (harcTurTanims.filter(item => item.id == yrsTurId).length > 0) {
      filterModel.kbsServisId = harcTurTanims.filter(item => item.id == yrsTurId)[0].bgpServisDto.kbsServisId;
    }
    HarcTurAktifTarifeGetir(filterModel.kbsServisId, yrsTurId).then(res => {

      var tempModelData = res.data.result.map(items => {
        return {
          key: items.id, id: items.id, tarifeAdi: items.tarifeAdi, yil: items.yil, ilkDeger: items.ilkDeger, sonDeger: items.sonDeger, bgsTarifeId: items.bgsTarifeId, bgpServisId: items.bgpServisDto.id, bgpGelirkodId: items.bgpGelirkodDto.id, bgpServisAdi: items.bgpServisDto.adi,
          bgpGelirkodAdi: items.bgpGelirkodDto.adi, birim: items.birim, deger: null, katSayi: null, kentselDonusum: null, islem: 1

        }
      });
      setAktifTarifeLists(tempModelData);
      aktifTarifeListsCount(tempModelData.length);
      setSpining(false);
    }).catch(ex => {
      setSpining(false);
    });
  }
  let hasSelected = selectedRowKeys.length > 0;

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      setSelectedRowKeys(selectedRowKeys);
      hasSelected = selectedRowKeys.length > 0;
    }
  };


  return <Spin tip={"Veriler Yükleniyor"} spinning={spining} > <Card
    style={{ margin: "20px" }}
    title={<h3 style={{ fontWeight: "bolder", color: "white" }}>Harç Tahakkuk Formu</h3>}
    className="ant-card-head-title-large"
  >
    <Row>
      <Form layout="inline" style={{ marginLeft: 10 }} onFinish={onFinish} >
        <Form.Item name="harcTurTanimObjectIdRef"
          rules={[{ required: false, message: 'Lütfen Harç Türü Seçiniz!' }]} >
          <Select
            showSearch
            allowClear
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            placeholder="Tür Tanımları"
            style={{ width: 200 }}
          // onChange={onBelgeTuruChange}
          >
            {harcTurTanims && harcTurTanims.map(bt => <Option key={bt.id} value={bt.id}>{bt.adi}</Option>)}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ marginBottom: 20, marginLeft: 10 }} onClick={() => {

          }}>
            <span style={{ fontWeight: "bold" }}>Sorgula</span>
          </Button>
        </Form.Item>
      </Form>
    </Row>
    <Row>
      <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
        <div style={{ marginBottom: 16 }}>
          <Button type="primary" onClick={tahakkukOlustur} disabled={!hasSelected} >
            Tahakkuk Oluştur
          </Button>
          <span style={{ marginLeft: 8 }}>
            {selectedRowKeys.length > 0 ? `Seçilen  ${selectedRowKeys.length} tane kayıt` : ''}
          </span>
        </div>

        <Table
          rowSelection={{
            type: selectionType,
            ...rowSelection,
          }}
          bordered rowKey={"id"} dataSource={aktifTarifeLists}
          title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h5 style={{ fontWeight: "bolder" }}>{''}</h5>
            {/* <ExcelExport
            fileName={'Aktif Tarifeler ' + " - " + queryDates[0]?.format(DATE_FORMAT) + "-" + queryDates[1]?.format(DATE_FORMAT)}
            downloadButton={<Button type="link" icon={<FileExcelOutlined style={{color: "green"}} />} />}
            sheets={[{ data: aktifTarifeLists, name: 'Test',keyTitles: aktifTarifeLists }]} /> */}
          </div>}
          columns={aktifTarifeColumns} pagination={true}
          onChange={
            (pagination, filters, sorter, extra) => {
              setAktifTarifeListsCount(extra.currentDataSource.length);
            }
          }
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
            total: aktifTarifeLists && aktifTarifeListsCount,
            showTotal: (total) => <div>{"Toplam: " + total}</div>
          }}
        />
      </Col>
    </Row>
    <Divider />
    <Row>
      <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
        <Card
          style={{ marginTop: "10px" }}
          title={<h4 style={{ fontWeight: "bolder", color: "white" }}>Harç Listesi</h4>}
          className="ant-card-head-title-large"
        >
          <Table
            bordered rowKey={"id"} dataSource={basvuruHarcLists}
            title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h5 style={{ fontWeight: "bolder" }}>{''}</h5>
              {/* <ExcelExport
            fileName={'Aktif Tarifeler ' + " - " + queryDates[0]?.format(DATE_FORMAT) + "-" + queryDates[1]?.format(DATE_FORMAT)}
            downloadButton={<Button type="link" icon={<FileExcelOutlined style={{color: "green"}} />} />}
            sheets={[{ data: basvuruHarcLists, name: 'Test',keyTitles: basvuruHarcLists }]} /> */}
            </div>}
            columns={kodHarcList} pagination={true}
            onChange={
              (pagination, filters, sorter, extra) => {
                setBasvuruHarcListsCount(extra.currentDataSource.length);
              }
            }
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
              total: basvuruHarcLists && aktifTarifeListsCount,
              showTotal: (total) => <div>{"Toplam: " + total}</div>
            }}
          />
        </Card>
      </Col>
    </Row>
  </Card>
  </Spin>
}

export default HarcEkleForm;